import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import React from "react";
import { IAttachmentFileModal } from "./IAttachmentFileModal";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import './attachmentFileModal.css'

export default function AttachmentFileModal({
    openModal,
    file,
    fileName,
    setOpenModal
}: IAttachmentFileModal) {


    const [open, setOpen] = React.useState<boolean>(openModal);
    const handleClose = () => {
        
        setOpen(false); setOpenModal(false)
    };

    React.useEffect(() => {
        setOpen(openModal);
    }, [openModal]);
    return (<>

        <Modal open={open}
            onClose={handleClose}
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
            className="border300"

        >
            <Box className="ModalCmp" style={{ overflow: "hidden", borderRadius: '5px' }}>
                <Grid container style={{ height: "60px", backgroundColor: "#707070", direction: "rtl", alignContent: "center", paddingRight: "20px", paddingLeft: "20px" }}>
                    <Grid item xs={6} style={{ justifyContent: "flex-start", display: "flex" }}>
                        <span style={{ color: "#fff", fontSize: "13px", transform: "translateY(20%)" }}>{fileName}</span>
                    </Grid>
                    <Grid item xs={6} style={{ justifyContent: "flex-end", display: "flex" }}>
                        <ArrowBackIcon style={{ color: "#fff", width: "24px", height: "24px" }} onClick={handleClose}></ArrowBackIcon>
                    </Grid>
                </Grid>
                <Grid style={{ backgroundColor: "#000", height: "30vh", justifyContent: "center", display: "flex" }} >
                    <img
                        src={file + "/true"}
                        style={{ width: "80%", height: "80%", justifyContent: "center", alignSelf: "center", display: "flex" }}></img>
                </Grid>

            </Box>

        </Modal>
    </>);
}